import React from "react";
import ActivityFooter from "../common/ActivityFooter";

const BurndownChartPage1 = ({ color, onBack, onContinue }) => {
  return (
    <div>
      <div className="content-area flex-grow">
        <div className="bg-gallery px-15 sm:px-50 lg:px-15 py-11">
          <div className="lg:max-w-520 mx-auto">
            <h1 className="uppercase font-bold text-gray-800 my-0 text-md">
              CREATE AN BURNDOWN CHART
            </h1>
          </div>
        </div>
        <div className="inner-content px-15 sm:px-50 lg:px-15 pt-19 mx-auto pb-25 lg:pb-8 text-gray-800">
          <p>
            If you’re an Excel genius, go ahead and do your thing. The rest of
            us will want to start from a template. We have one for you.
          </p>
        </div>
      </div>

      <ActivityFooter color={color} onBack={onBack} onContinue={onContinue} />
    </div>
  );
};

export default BurndownChartPage1;
